import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import {
  createNewPermission,
  deleteAPermission,
  updateAPermission,
} from '../../../../../api/user/update-permission'

export const initialState = {
  updatePermissionError: null,
  isUpdatingPermission: false,
}

export const createPermission = createAsyncThunk(
  'permissionManagement/createPermission',
  async (args, { rejectWithValue }) => {
    try {
      const { code, description, application } = args
      const response = await createNewPermission({ code, description, application })
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const updatePermission = createAsyncThunk(
  'permissionManagement/updatePermission',
  async (args, { rejectWithValue }) => {
    try {
      const { code, description, application } = args
      const response = await updateAPermission({ code, description, application })
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const deletePermission = createAsyncThunk(
  'permissionManagement/deletePermission',
  async (args, { rejectWithValue }) => {
    try {
      const { permission, application } = args
      const response = await deleteAPermission({ permission, application })
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const updatePermissionSlice = createSlice({
  name: 'updatePermission',
  initialState,
  reducers: {
    resetUpdatePermissionState: (state) => {
      state.isUpdatingPermission = false
      state.updatePermissionError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Updating Permission
      .addCase(updatePermission.pending, (state) => {
        state.isUpdatingPermission = true
        state.updatePermissionError = null
      })
      .addCase(updatePermission.fulfilled, (state) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = null
      })
      .addCase(updatePermission.rejected, (state, action) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = action.payload
      })
      // Creating Permission
      .addCase(createPermission.pending, (state) => {
        state.isUpdatingPermission = true
        state.updatePermissionError = null
      })
      .addCase(createPermission.fulfilled, (state) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = null
      })
      .addCase(createPermission.rejected, (state, action) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = action.payload
      })
      // Deleting Permission
      .addCase(deletePermission.pending, (state) => {
        state.isUpdatingPermission = true
        state.updatePermissionError = null
      })
      .addCase(deletePermission.fulfilled, (state) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = null
      })
      .addCase(deletePermission.rejected, (state, action) => {
        state.isUpdatingPermission = false
        state.updatePermissionError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { resetUpdatePermissionState } = updatePermissionSlice.actions

export default updatePermissionSlice.reducer
